export default [
  {
    id: 1,
    heading: 'Today, I am grateful for',
    percent: 34,
  },
  {
    id: 2,
    heading: 'Challenges I face',
    percent: 68,
  },
  {
    id: 3,
    heading: 'I am looking to develop',
    percent: 100,
  },
];
